import { DirectUpload } from '@rails/activestorage'
import Alpine from 'alpinejs'

const data = (params = {}) => ({
  /**
   *  Data
   */
  sizeLimit: -1,
  url: '/rails/active_storage/direct_uploads', // upload url, 預設是rails的rails_direct_uploads_path
  files: [],
  fileTouched: false,
  status: 'init', // ['init', 'uploading', 'success', 'error']
  result: [],

  /**
   *  Targets
   */

  targets: {
    files: {
      ['x-ref']: 'uploadFilesBtn',
      ['@change']: 'onChange',
      ['@drop.prevent']: 'onDrop',
      ['@dragover.prevent']: '',
      ['@direct-upload:manaul-cancel.window']: "onCancel",
    },
  },

  /**
   *  Main & Event Callback
   */

  init() {
    this.filesValueChanged()
    this.progressValueChanged()
  },

  onChange(e) {
    this.fileTouched = true
    this.files = [...e.currentTarget.files]
  },

  onDrop(e) {
    this.fileTouched = true
    this.files = this.getTransferFile(e)
  },

  onCancel() {
    this.resetData()
  },

  /**
   *  Value Changed
   */
  filesValueChanged() {
    this.$watch('files', files => {
      this.resetData()
      if (files.length === 0) { return }

      const hasError = files.find( file => !this.checkFile(file) )
      if ( hasError ) {
        this.status = 'error'
        return
      }

      const resultData = files.map(file => ({ name: file.name, progress: 0, signedId: '' }))
      this.result = this.result.concat(resultData)

      this.status = 'uploading'
      this.result.forEach( ({ name, progress }, idx) => {
        if (progress === 100) { return }

        const file = files.find( file => file.name === name )
        if ( !file ) { return }

        this.upload(file, idx)
      })
      // NOTICE: 去除file field所選檔案，避免又在submit時再度上傳一次
      this.$refs.uploadFilesBtn.value = ''
    })
  },

  progressValueChanged() {
    this.$watch(
      () => JSON.stringify(this.result.map( item => item.progress && item.signedId )),
      async (signedIds) => {
        signedIds = JSON.parse(signedIds)
        const isAllFinished = signedIds.every(signedId => signedId)
        if ( isAllFinished ) {
          await Alpine.nextTick()
          this.status = 'success'
        }
      }
    )
  },

  /**
   *  Private Function
   */

  getTransferFile(e) {
    if (e.dataTransfer.items) {
      return (
        [...e.dataTransfer.items]
          .filter( item => item && item.kind === 'file' )
          .map( item => item.getAsFile() )
      )
    } else {
      return (
        [...e.dataTransfer.files]
          .filter( item => item )
      )
    }
  },

  upload( file, idx ) {
    if ( !this.url || !file ) { return }

    const self = this
    const callbacks = {
      // MUST: becase `DirectUpload` will use
      directUploadWillStoreFileWithXHR(request) {
        request.upload.addEventListener('progress', ({ loaded, total }) => {
          self.result[idx].progress = Math.floor(loaded * 100.0 / total)
        })
      },
    }
    const instance = new DirectUpload(file, this.url, callbacks)

    instance.create((error, blob) => {
      if (error) {
        this.status = 'error'
        console.error(error)
      } else {
        // Add an appropriately-named hidden input to the form
        // with a value of blob.signed_id
        this.result[idx].id = blob.id
        this.result[idx].signedId = blob.signed_id
        this.result[idx].progress = 100
      }
    })
  },

  resetData() {
    this.status = 'init'
  },

  checkFile( file ) {
    return (this.sizeLimit === -1 || file.size <= this.sizeLimit)
  },

  ...params
})

Alpine.data('directUploadFiles', data)
export default data
